<template>
  <div class="mb-4">
    <div class="flex justify-center items-center w-full h-12 mt-6">
      <div
        class="flex justify-center items-center"
      >
        <div class="maxMinText text-right">
          {{ minSizeRange }}
          <span class="block text-base font-medium"><slot name="measure-text" /></span>
        </div>
        <div class="dotLegend" />
        <div class="dotLegend dotLegend--sm" />
        <div class="dotLegend dotLegend--md" />
        <div class="dotLegend dotLegend--lg" />
        <div class="dotLegend dotLegend--xl" />
        <div class="maxMinText">
          {{ maxSizeRange }}
          <span class="block text-base font-medium"><slot name="measure-text" /></span>
        </div>
      </div>
    </div>
    <div
      v-if="$slots.info"
      class="flex justify-center items-center w-full mt-4 mb-2 text-base-900 text-base"
    >
      <div class="w-full text-center">
        <slot
          name="info"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    minSizeRange: { type: String },
    maxSizeRange: { type: String },
  },
};
</script>
<style scoped>
.dotLegend {
  @apply h-4 w-4 m-2 rounded-full bg-base-400;
  &--sm {
    @apply h-6 w-6;
  }
  &--md {
    @apply h-8 w-8;
  }
  &--lg {
    @apply h-10 w-10;
  }
  &--xl {
    @apply h-12 w-12;
  }
}
.maxMinText {
  @apply text-base-900 text-lg font-bold mx-5 leading-2;
}
</style>
